import { WaitingChargeConfig } from '@shared-features/models/waiting-charge-config.model';

export class UpdateWaitingChargeConfigDto {
  isEnabled: boolean;
  gracePeriodHours: number;
  hourlyWindowHours?: number;
  hourRateSar?: number;
  dailyRateSar?: number;

  constructor(config: WaitingChargeConfig) {
    this.isEnabled = config.isEnabled;
    this.gracePeriodHours = config.gracePeriodHours;
    this.hourlyWindowHours = config.hourlyWindowHours;
    this.hourRateSar = config.hourRateSar;
    this.dailyRateSar = config.dailyRateSar;
  }
}
